// packages/content/src/assets/nature.ts
import type { AssetBank } from '../schema/assets';
export default {
  'fruit.apple': { src: 'code:fruit' }, 'fruit.orange': { src: 'code:fruit' }, 'fruit.pear': { src: 'code:fruit' },
  'fruit.peach': { src: 'code:fruit' }, 'fruit.cherry': { src: 'code:fruit' },
  'shell.cockle': { src: 'code:shell' }, 'shell.cowrie': { src: 'code:shell' }, 'shell.scallop': { src: 'code:shell' },
  'shell.sand_dollar': { src: 'code:shell' }, 'shell.conch': { src: 'code:shell' },
} satisfies AssetBank;
